module.exports = __webpack_public_path__ + "img/arrow.a434d7d3.svg";